export default class Navigation {
  constructor(root) {
    this.root = root;

    let bg_container = this.root.querySelector(".js-nav-bg");
    let meganav_items = this.root.querySelectorAll(".js-meganav-item");
    let search_btn = this.root.querySelector(".js-navigation-search");
    let nav_container = this.root.querySelector(".js-navigation-container");
    let mobile_toggle_btn = this.root.querySelector(".js-navigation-mobile-toggle");

    meganav_items.forEach((meganav_item) => {
      meganav_item.addEventListener("mouseenter", (e) => {
        if (window.innerWidth > 770) {
          bg_container.classList.add("--active");
        }
      });

      meganav_item.addEventListener("mouseleave", (e) => {
        if (window.innerWidth > 770) {
          bg_container.classList.remove("--active");
        }
      });

      meganav_item.addEventListener("click", (e) => {
        if (window.innerWidth <= 770) {
          let all_subnavs = this.root.querySelectorAll(".js-navigation-subnav");
          let all_toggles = this.root.querySelectorAll(".js-navigation-subnav-toggle");
          let active_subnav = meganav_item.querySelector(".js-navigation-subnav");
          let active_toggle = meganav_item.querySelector(".js-navigation-subnav-toggle");

          let opened_nav_item = null;

          if (all_subnavs) {
            all_subnavs.forEach((subnav) => {
              if (subnav.classList.contains("--active")) {
                opened_nav_item = subnav;
              }

              subnav.classList.remove("--active");
            });
          }

          if (all_toggles) {
            all_toggles.forEach((toggle) => {
              toggle.innerText = "[+]";
            });
          }

          if (active_subnav != opened_nav_item) {
            if (active_subnav) {
              active_subnav.classList.add("--active");
            }

            if (active_toggle) {
              active_toggle.innerText = "[-]";
            }
          }
        }
      });
    });

    search_btn.addEventListener("click", (e) => {
      e.preventDefault();

      if (search_btn.parentElement.classList.contains("--active")) {
        search_btn.parentElement.classList.remove("--active");
      } else {
        search_btn.parentElement.classList.add("--active");
      }
    });

    mobile_toggle_btn.addEventListener("click", (e) => {
      e.preventDefault();

      if (nav_container.classList.contains("--active")) {
        nav_container.classList.remove("--active");
      } else {
        nav_container.classList.add("--active");
      }
    });
  }
}
